import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { PointOfSaleSummary } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';
import { Product, Rubric } from 'src/app/services/api/fulle/fulle-product/fulle-product.interface';

@Component({
  selector: 'app-fulle-rub-prod-list',
  templateUrl: './fulle-rub-prod-list.component.html',
  styleUrls: ['./fulle-rub-prod-list.component.css']
})
export class FulleRubProdListComponent {

  @Input() rubrics$!: Rubric[]; // pipe rubsfilter bosse dessus
  @Input() products$!: Product[] | Observable<Product[]>;
  @Input() newRubricsDisplay$!: Observable<Rubric[]>;

  @Input() pointOfsale!: PointOfSaleSummary;
  @Input() merchantClient$!: Observable<any>; // on gardera any ici pour l’instant (API externe)
  @Input() user_!: unknown;

  @Input() loaderpop = false;
  @Input() count = 0;
  @Input() more_products_button = false;
  @Input() limit_from = 0;
  @Input() scrollingElementProd!: HTMLElement;

  @Output() openProdDialEvent = new EventEmitter<Product>();
  @Output() deconnectionEvent = new EventEmitter<void>();
  @Output() moreProductsEvent = new EventEmitter<Rubric>();

  openProdDial(prod: Product, mode: 'add' | 'edit' = 'add'): void {
    this.openProdDialEvent.emit(prod);
  }

  Moreproducts(rub: Rubric): void {
    this.moreProductsEvent.emit(rub);
  }

  isDisplaySquare(): boolean {
    const mode = (this.pointOfsale as any)?.webshop_display_mode;
    return !mode;
  }

  isDisplayRectangle(): boolean {
    const mode = (this.pointOfsale as any)?.webshop_display_mode;
    return !!mode;
  }

}
